import { LocaleUtils } from "@grandvisionhq/utils";
const getLocaleSwitcherMenuLabel = (fallbackLocale) => {
  const selectedLocale = LocaleUtils.getLocaleFromCookie() ?? fallbackLocale;
  const menuLabel = selectedLocale.substring(0, 2);
  return menuLabel.toUpperCase();
};
export {
  getLocaleSwitcherMenuLabel
};
//# sourceMappingURL=get-locale-switcher-menu-label.js.map
